import { useLogout } from '@/js/libs/use-auth';

import useLogoutCallback from './useLogoutCallback.ts';

const useAppLogout = () => {
  const logoutCallback = useLogoutCallback();

  const logout = useLogout({
    onLogout: logoutCallback,
  });

  return logout;
};

export default useAppLogout;
